module.exports = __webpack_public_path__ + "static/633fe7b3.app_icon2.jpg";